// Quién ve los módulos restringidos por usuario (pedido del 26/09/2026).
// Espejo de App\Support\AccesoModulos en el backend, que es quien de verdad
// bloquea: aquí solo se decide si mostrar el menú y la ruta. Si se cambia una
// lista, cambiar las dos.
//
//   37 saezyus · 39 salazarg · 40 gavidiaj  (ids de producción)

const MODULOS = {
  'seguimiento-egresados': { roles: ['admin'], usuarios: [37, 39, 40] },
  beneficiarios: { roles: ['admin'], usuarios: [37, 40] },
};

export const puedeVerModulo = (modulo) => {
  const regla = MODULOS[modulo];
  if (!regla) return false;
  let rol = null;
  let userId = NaN;
  try {
    rol = localStorage.getItem('role');
    userId = Number(localStorage.getItem('user'));
  } catch {
    return false;
  }
  return regla.roles.includes(rol) || regla.usuarios.includes(userId);
};

export default puedeVerModulo;
